import axios, { AxiosInstance } from 'axios';

enum APP_ENVIROMENT {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  SANDBOX = 'sandbox',
  PRODUCTION = 'production',
}

enum API_URL {
  DEVELOPMENT = 'https://localhost:3000/api/',
  STAGING = 'https://api-staging.covideo.com/',
  SANDBOX = 'https://api-sandbox.covideo.com/',
  PRODUCTION = 'https://api.covideo.com/',
}

export const isEnvDevelopment: boolean =
  !import.meta.env.VITE_ENV ||
  import.meta.env.VITE_ENV === APP_ENVIROMENT.DEVELOPMENT;

export const isEnvStaging: boolean =
  import.meta.env.VITE_ENV === APP_ENVIROMENT.STAGING;

export const isEnvSandbox: boolean =
  import.meta.env.VITE_ENV === APP_ENVIROMENT.SANDBOX;

export const isEnvProduction: boolean =
  import.meta.env.VITE_ENV === APP_ENVIROMENT.PRODUCTION;

const getApiUrl = (): API_URL => {
  if (isEnvStaging) {
    return API_URL.STAGING;
  }
  if (isEnvSandbox) {
    return API_URL.SANDBOX;
  }
  if (isEnvProduction) {
    return API_URL.PRODUCTION;
  }

  return API_URL.DEVELOPMENT;
};

// Export the environment URL -> remove this after fetcher is removed
export const apiExpress: API_URL = getApiUrl();

export const API: AxiosInstance = axios.create({
  baseURL: apiExpress,

  // Custom headers
  headers: {
    'Content-Type': 'application/json',
    ...(!!import.meta.env.VITE_API_KEY
      ? { apikey: import.meta.env.VITE_API_KEY }
      : {}),
    // Add any other common headers you need
  },
});
